// ----- COUNTRIES -----

const filterCountryLinks = document.getElementById('filterCountryLinks');
if (filterCountryLinks) {
    const countryLinks = Array.from(filterCountryLinks.children);
    countryLinks.forEach(function(child) {
        child.children[0].addEventListener('click', function(e) {
            redirectWithQuery(e, this);
        });
    });
}

// Collapsed links
const showMoreCountries = document.getElementById('showMoreCountries');
if (showMoreCountries) {
    const moreCountries = Array.from(showMoreCountries.children);
    moreCountries.forEach(function(child) {
        child.children[0].addEventListener('click', function(e) {
            redirectWithQuery(e, this);
        });
    });
}


// ----- PLACES -----

const filterPlaceLinks = document.getElementById('filterPlaceLinks');
if (filterPlaceLinks) {
    const filterChildren = Array.from(filterPlaceLinks.children);
    filterChildren.forEach(function(child) {
        child.children[0].addEventListener('click', function(e) {
            redirectWithQuery(e, this);
        });
    });
}

// Collapsed links
const showMorePlaces = document.getElementById('showMorePlaces');
if (showMorePlaces) {
    const morePlaces = Array.from(showMorePlaces.children);
    morePlaces.forEach(function(child) {
        child.children[0].addEventListener('click', function(e) {
            redirectWithQuery(e, this);
        });
    });
}


// ----- Functions -----

function redirectWithQuery(event, self) {
    event.preventDefault();

    let query = window.location.search.substring(1);
    location.href = self.getAttribute('href') + '?' + query;
}
